import React from 'react';
import { Select, Label, Button, SelectValue, Popover, ListBox, ListBoxItem } from 'react-aria-components';

type SearchComboBoxProps = Readonly<{
  filterLabel: string;
  items: { key: string; label: string }[];
  selectedKey?: string;
  onChange?: (value: string) => void;
}>;

export default function SearchDropdown({ filterLabel, items, selectedKey = undefined, onChange }: SearchComboBoxProps) {
  return (
    <Select className="search-dropdown" defaultValue={selectedKey} onChange={onChange}>
      <Label className="search-dropdown__label">{filterLabel}</Label>
      <Button
        className="search-dropdown__toggle-button"
        aria-label={`Select a ${filterLabel} option`}
        aria-labelledby={null} // Override react-aria's default behavior
      >
        <SelectValue className="search-dropdown__select-value" />
        <svg className="search-dropdown__toggle-button-icon icon" aria-hidden="true">
          <use href="/dist/assets/icons/sprite.svg#nav-arrow-down"></use>
        </svg>
      </Button>
      <Popover className="search-dropdown__popover" shouldFlip={false} offset={0}>
        <ListBox className="search-dropdown__listbox" items={items}>
          {item => (
            <ListBoxItem id={item.key} className="search-dropdown__listbox-item">
              {item.label}
            </ListBoxItem>
          )}
        </ListBox>
      </Popover>
    </Select>
  );
}
